export default {
  // 路由国际化
  route: {
    dashboard: '首页',
    document: '项目文档'
  },
  // 登录页面国际化
  login: {
    title: '登录',
    subTitle: '欢迎使用海外账号批发平台',
    formLogin: '登录',
    formUserNamePlaceholder: '请输入用户名',
    formPasswordPlaceholder: '请输入密码',
    formUserNameErrMsg: '用户名不能为空',
    formPasswordErrMsg: '密码不能为空',
    formErrMsg: '登录出错，轻刷新重试',
    formSuccess: '欢迎使用',
    forgotPassword: '忘记密码？',
    noAccount: '还没有账号？',
    register: '立即注册',
    slogan1: '隐私保护严格，任何人无法获取内容信息',
    subSlogan1: '优质账号 品质保证 售后无忧',
    slogan2: '支持 区块链钱包去中心化支付 交易便捷',
    subSlogan2: '国际化，路由配置，状态管理应有尽有',
    slogan3: '稳定可靠 快速发货',
    subSlogan3: '专业团队维护 长期稳定 持续更新'
  },
  navbar: {
    退出: '退出登录'
  },
  common: {
    是: '是',
    否: '否',
    登录成功: '登录成功',
    已在其他标签页打开: '已在其他标签页打开',
    请关闭当前标签页: '请关闭当前标签页',
    添加: '添加',
    删除: '删除',
    编辑: '编辑',
    取消: '取消',
    确认: '确认',
    分组: '分组',
    确定删除吗: '确定删除吗？',
    确认删除: '确认删除',
    搜索用户: '搜索用户',
    小时: '小时',
    天: '天',
    表情: '表情',
    图片: '图片',
    历史: '历史',
    快捷回复: '快捷回复',
    常用表情: '常用表情',
    手势: '手势',
    心形: '心形',
    自然: '自然',
    食物: '食物',
    节日: '节日',
    天气: '天气',
    消息管理: '消息管理',
    全部: '全部',
    音频: '音频',
    视频: '视频',
    文件: '文件',
    发送: '发送',
    更多操作: '更多操作',
    请输入消息: '请输入消息',
    删除成功: '删除成功',
    在线: '在线',
    离线: '离线',
    封禁用户: '封禁用户',
    打开: '打开',
    关闭: '关闭',
    暂无数据: '暂无数据',
    已封禁: '已封禁',
    资料卡: '资料卡',
    签名: '这个人很懒，什么都没留下',
    手机号: '手机号',
    昵称: '昵称',
    性别: '性别',
    备注: '备注',
    添加备注: '添加备注',
    邮箱: '邮箱',
    发送消息: '发送消息',
    修改备注: '修改备注',
    操作成功: '操作成功',
    操作失败: '服务繁忙,请稍后再试',
    全选: '全选',
    消息发送失败: '消息发送失败',
    请完善表单信息: '请完善表单信息',
    表单验证失败: '表单验证失败',
    秒: '秒',
    分钟前: '分钟前',
    刚刚: '刚刚',
    昨天: '昨天',
    前天: '前天',
    日: '日',
    一: '一',
    二: '二',
    三: '三',
    四: '四',
    五: '五',
    六: '六'
  },
  // 工具
  setting: {
    langSetting: '语言',
    zh: '中文',
    en: '英文',
    pt: '葡萄牙语',
    ru: '俄语'
  },
  //axios
  xmlRequest: {
    501: '获取列表失败',
    502: '用户名不能为空',
    503: '未找到该代理',
    504: '查询失败，请稍后重试',
    505: '创建失败',
    506: '不存在',
    507: '更新失败',
    508: '代理不存在',
    509: '删除失败',
    510: '缺少必要参数',
    511: '用户名或密码错误',
    512: '登录失败，请稍后重试',
    513: '获取统计数据失败',
    514: '获取收入趋势失败',
    515: '请选择要上传的文件',
    516: '获取订单列表失败',
    517: '获取详情失败',
    518: '获取启用的支付方式失败',
    519: '无效的参数格式',
    401: '用户不存在或登录状态异常',
    提示: '提示',
    当前登录已失效: '当前登录已失效',
    确认: '确认',
    再想想: '再想想'
  },
  undefined: '服务繁忙,请稍后再试',
  page: {
    退出: '退出',
    个人信息: '个人信息',
    点击联系客服: '点击联系客服',
    余额: '余额',
    主页: '主页',
    购买账户: '购买账户',
    购买记录: '购买记录',
    客服: '客服',
    充值: '充值',
    登录: '登录',
    在线客服: '在线客服',
    实时订单: '实时订单',
    当前在线人数: '当前在线人数',
    今日售出账号: '今日售出账号',
    订单号: '订单号',
    下单时间: '下单时间',
    未登录: '未登录',
    账号列表: '账号',
    全部: '全部',
    库存: '库存',
    价格: '价格',
    操作: '操作',
    购买: '购买',
    '本站售出账号请妥善保存，7天后删除数据': '本网站出售账号请妥善保存，7天后删除数据',
    请输入订单号: '请输入订单号',
    账号类型: '账号类型',
    请选择账号类型: '请选择账号类型',
    购买时间: '购买时间',
    搜索: '搜索',
    重置: '重置',
    充值类型: '充值类型',
    充值金额: '充值金额',
    立即充值: '立即充值',
    充值通告: '充值通告',
    充值记录: '充值记录',
    订单ID: '订单ID',
    请输入订单ID: '请输入订单ID',
    发送者钱包地址: '发送者钱包地址',
    接收者钱包地址: '接收者钱包地址',
    交易哈希: '交易哈希',
    金额: '金额',
    类型: '类型',
    状态: '状态',
    时间: '时间',
    订单编号: '订单编号',
    您的钱包地址: '您的钱包地址',
    系统钱包地址: '系统钱包地址',
    确认充值: '确认充值',
    复制: '复制',
    当前USDT支付区块网络协议为TRC20: '当前USDT支付区块网络协议为TRC20',
    请使用链手机钱包扫码支付: '请使用链手机钱包扫码支付',
    过程中产生的交易手续费由您自行承担: '过程中产生的交易手续费由您自行承担',
    时: '时',
    分: '分',
    秒: '秒',
    请输入你的钱包地址: '请输入你的钱包地址',
    查看详情: '查看详情',
    复制账号: '复制账号',
    进入管理端: '进入管理端',
    进入用户端: '进入用户端',
    今日已出售账号: '今日已出售账号',
    用户: '用户',
    '请先安装 TronLink 钱包': '请先安装 TronLink 钱包',
    请输入您的钱包地址: '请输入您的钱包地址',
    充值详情: '充值详情',
    充值成功: '充值成功',
    充值失败: '充值失败',
    充值中: '充值中',
    充值状态: '充值状态',
    充值时间: '充值时间',
    订单支付: '订单支付',
    应付总额: '应付总额',
    支付: '支付',
    购买数量: '购买数量',
    购买成功: '购买成功',
    产品名称: '产品名称',
    产品描述: '产品描述',
    账号: '账号',
    密码: '密码',
    支付金额: '支付金额',
    订单状态: '订单状态',
    账号信息: '账号信息',
    已完成: '已完成',
    处理中: '处理中',
    连接钱包: '连接钱包',
    已连接钱包: '已连接钱包',
    钱包余额: '钱包余额',
    请先连接钱包: '请先连接钱包',
    未获取到钱包地址: '未获取到钱包地址',
    钱包连接成功: '钱包连接成功',
    链接钱包: '链接钱包',
    手机钱包App扫码支付: '手机钱包App扫码支付',
    浏览器TronLink支付: '浏览器TronLink支付',
    钱包已连接: '钱包已连接',
    钱包详情: '钱包详情',
    请先安装TronLink钱包: '请先安装TronLink钱包',
    钱包地址已复制: '钱包地址已复制',
    复制失败: '复制失败',
    连接钱包失败: '连接钱包失败',
    检查授权状态失败请刷新页面重试: '检查授权状态失败请刷新页面重试',
    '授权超时，请重新尝试': '授权超时，请重新尝试',
    请输入当前连接的钱包地址: '请输入当前连接的钱包地址',
    '授权请求已发送，请在钱包中确认': '授权请求已发送，请在钱包中确认',
    请先完成授权操作: '请先完成授权操作',
    '支付失败，请重试': '支付失败，请重试',
    请安装钱包应用: '请安装钱包应用',
    用户拒绝了授权请求: '用户拒绝了授权请求',
    获取钱包余额失败: '获取钱包余额失败',
    请在钱包中完成授权操作: '请在钱包中完成授权操作',
    授权成功: '授权成功',
    授权失败: '授权失败',
    支付成功: '支付成功',
    支付失败: '支付失败',
    请使用手机钱包扫码: '请使用手机钱包扫码',
    授权成功正在处理支付: '授权成功正在处理支付',
    钱包地址为空: '钱包地址为空',
    USDT合约地址未配置: 'USDT合约地址未配置',
    系统钱包地址未配置: '系统钱包地址未配置',
    合约交互失败: '合约交互失败',
    钱包地址未获取: '钱包地址未获取',
    您的USDT余额不足: '您的USDT余额不足',
    授权失败请重试: '授权失败请重试',
    钱包连接失败: '钱包连接失败',
    复制成功: '复制成功',
    订单详情: '订单信息',
    最小充值金额: '最小充值金额',
    最小充值金额说明: '请输入最小充值金额和说明',
    保持钱包状态正常: '保持钱包状态正常',
    继续充值: '继续充值',
    充值成功点击刷新返回首页: '充值成功点击刷新返回首页',
    取消:'取消'
  },
  register: {
    title: '注册',
    subTitle: '创建新账号',
    formRegister: '注册',
    formUserNamePlaceholder: '请输入用户名',
    formEmailPlaceholder: '请输入电子邮件',
    formPasswordPlaceholder: '请输入密码',
    formConfirmPasswordPlaceholder: '请确认密码',
    formUserNameErrMsg: '用户名不能为空',
    formEmailErrMsg: '电子邮件不能为空',
    formEmailFormatErrMsg: '请输入有效的电子邮件地址',
    formPasswordErrMsg: '密码不能为空',
    formPasswordLengthErrMsg: '密码长度不能少于6位',
    formConfirmPasswordErrMsg: '请确认密码',
    formPasswordNotMatchErrMsg: '两次输入的密码不一致',
    formAgreementLabel: '我已阅读并同意',
    formPrivacyLink: '隐私政策',
    formAgreementAnd: '和',
    formTermsLink: '使用条款',
    formAgreementErrMsg: '请阅读并同意隐私政策和使用条款',
    formHaveAccount: '已有账号？',
    formLoginLink: '登录',
    success: '注册成功',
    error: '注册失败',
    inviteCode: '邀请码 （选填）'
  },
  forgotPassword: {
    title: '忘记密码',
    subTitle: '请输入您的电子邮件地址，我们将向您发送重置密码的验证码',
    formEmailPlaceholder: '请输入电子邮件',
    formCodePlaceholder: '请输入验证码',
    formEmailErrMsg: '电子邮件不能为空',
    formEmailFormatErrMsg: '请输入有效的电子邮件地址',
    formCodeErrMsg: '验证码不能为空',
    formSendCode: '发送验证码',
    formSubmit: '重置密码',
    formBackToLogin: '返回登录',
    formEmailRequired: '请先输入电子邮件地址',
    codeSent: '验证码已发送',
    codeSendError: '验证码发送失败',
    success: '密码重置成功',
    error: '密码重置失败'
  }
};
